import { Box } from '@mui/material';

interface IProps {
	children: any;
	styleObj?: any;
}
export const BasicCard = ({ children, styleObj }: IProps) => {
	return (
		<Box
			sx={{
				...styleObj,
				minWidth: { sm: '500px' },
				padding: '40px',
				borderRadius: '10px',
				boxShadow: 'grey 0px 1px 8px',
			}}
		>
			{children}
		</Box>
	);
};
